import { tokenService, userService } from '../services';
import router from '../router';
import Vue from 'vue'

// La sesión parte vacía: el usuario solo se da por conocido cuando lo confirma
// el backend en login(), nunca a partir de lo guardado en el navegador.
const initialState = { status: { loggedIn: false }, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        // Se resuelve cuando el usuario ya está en el store (o el login falló),
        // para que main.js monte la app y el router decida con ese usuario.
        login({ dispatch, commit }, { username, password }) {
            commit('loginRequest', { username });

            return tokenService.authenticate(username, password)
                .then(
                    token => {
                        return userService.getCurrentUser()
                            .then(
                                user => {
                                    commit('loginSuccess', user);
                                    // Las exportaciones son solo de staff.
                                    if (user.is_staff) {
                                        dispatch('exportaciones/reanudar', null, { root: true });
                                    }
                                },
                                error => {
                                    commit('loginFailure', error)
                                    Vue.prototype.$keycloak.logout()
                                }
                            );
                    },
                    error => {
                        commit('loginFailure', error);
                        Vue.prototype.$keycloak.logout()
                    }
                );
        },
        logout({ commit, dispatch }) {
            tokenService.clear();
            dispatch('exportaciones/olvidar', null, { root: true });
            Vue.prototype.$keycloak.logout()
            commit('logout');
            router.push('/');
        }
    },
    mutations: {
        loginRequest(state, user) {
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = { loggedIn: false };
            state.user = null;
        },
        logout(state) {
            state.status = { loggedIn: false };
            state.user = null;
        }
    }
}
